import { apiInstance } from "../config/api";

export const productService = {
  async getMyNicheCategories() {
    const response = await apiInstance.get("/product-management/me/niche-categories");
    return response.data;
  },

  async updateMyNicheCategories(payload: { nicheCategoryIds: string[] }) {
    const response = await apiInstance.patch(
      "/product-management/me/niche-categories",
      payload,
    );
    return response.data;
  },

  async listMyProducts({
    page,
    limit,
    search,
    categoryId,
    condition,
    isNegotiable,
    sortBy,
  }: {
    page?: number;
    limit?: number;
    search?: string;
    categoryId?: string;
    condition?: string;
    isNegotiable?: boolean;
    sortBy?: string;
  }) {
    const response = await apiInstance.get("/product-management/me/products", {
      params: {
        ...(typeof page === "number" ? { page } : {}),
        ...(typeof limit === "number" ? { limit } : {}),
        ...(search ? { search } : {}),
        ...(categoryId ? { "filter.categoryId": categoryId } : {}),
        ...(condition ? { "filter.condition": condition } : {}),
        ...(typeof isNegotiable === "boolean"
          ? { "filter.isNegotiable": isNegotiable }
          : {}),
        ...(sortBy ? { sortBy } : {}),
      },
    });
    return response.data;
  },

  async createProduct(payload: Record<string, any>) {
    const response = await apiInstance.post(
      "/product-management/me/products",
      payload,
    );
    return response.data;
  },

  async updateProduct(productId: string, payload: Record<string, any>) {
    const response = await apiInstance.patch(
      `/product-management/me/products/${productId}`,
      payload,
    );
    return response.data;
  },

  async deleteProduct(productId: string) {
    const response = await apiInstance.delete(
      `/product-management/me/products/${productId}`,
    );
    return response.data;
  },
};